import { BrowserRouter as Router, Switch, Route } from "react-router-dom";
import App from './App'

//Professionals
import ProfessionalForm from './components/Professionals/ProfessionalForm'
import ProfessionalManager from './components/Professionals/ProfessionalManager'
import ProfessionalEditForm from './components/Professionals/ProfessionalEditForm'
//Patients
import PatientForm from './components/Patients/PatientForm'
import PatientManager from './components/Patients/PatientManager'
import PatientEditForm from './components/Patients/PatientEditForm'
import PatientTimeline from './components/Patients/PatientTImeline'

import React from 'react'

export default function routes() {
    return (
        <Router basename={process.env.PUBLIC_URL}>
            <Switch>
                <Route exact path="/">
                    <App />
                </Route>
                <Route exact path="/professional/add">
                    <App component={<ProfessionalForm />} />
                </Route>
                <Route exact path="/professional">
                    <App component={<ProfessionalManager />} />
                </Route>
                <Route exact path="/professional/edit">
                    <App component={<ProfessionalEditForm />} />
                </Route>
                <Route exact path="/patients/add">
                    <App component={<PatientForm />} />
                </Route>
                <Route exact path="/patients/edit">
                    <App component={<PatientEditForm />} />
                </Route>
                <Route exact path="/patients">
                    <App component={<PatientManager />} />
                </Route>
                <Route exact path="/patients/timeline">
                    <App component={<PatientTimeline />} />
                </Route>
            </Switch>
        </Router>
    )
}
